import React from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';
import './modalstyles.css';
import ButtonComponent from '../../customButton';
 
const ModalWrapper = ({ open, onClose, title, children, buttons }) => {
  
  return (
    <Modal
    open={open}
    backdrop="static"
    onClose={(event, reason) => {
      // Prevent closing when clicking outside the modal
      if (reason !== 'backdropClick') {
        onClose();
      }
    }}
    slotProps={{
      backdrop: {
        style: { backgroundColor: 'rgba(0, 0, 0, 0.5)' },
      },
    }}
  >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 450,
          maxHeight: 500,
          bgcolor: 'background.paper',
          p: 0, /* No padding around the modal */
          borderRadius: 3,
          boxShadow: 24,
        }}
      >
        {/* Header Box */}
        <Box className="modal-header">
          <Typography variant="h5">{title}</Typography>
        </Box>
 
        {/* Body Box */}
        <Box className="modal-body">
          {children} {/* Render the children passed to the ModalWrapper */}
        </Box>
 
        {/* Buttons Section */}
        <Box display="flex" justifyContent="flex-end" gap={2} sx={{ pr: 4, pl: 4, pb: 4, pt:1}}>
          {buttons?.map((button, index) => {
            // Dynamically apply background color if variant is 'contained'
            const buttonSx = button.variant === 'contained'
              ? { backgroundColor: '#2160f3', textTransform: 'none', ...button.sx } // Apply custom background color for contained
              : { textTransform: 'none', ...button.sx }; // Default styles for other variants
 
            return (
              <ButtonComponent
                key={index}
                variant={button.variant}
                onClick={button.onClick}
                disabled={button.disabled || false}
                className={button.className}
                ctaText={button.label}
              />
            );
          })}
        </Box>
      </Box>
    </Modal>
  );
};
 
export default ModalWrapper;